import { useEffect } from "react";
import { bindActionCreators } from "redux";
import { setVocabularies, setLanguage, setSearchFields } from "../redux/actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import axios from "axios";
import { setArabicMarkup } from "../common/helper";

const AppContainer = ({ setLanguage, setVocabularies, vocabularies, children, setSearchFields }) => {
  useEffect(() => {
    axios.get('./data/languages.json')
      .then(function (result) {
        setLanguage(result.data.languages);
      });
    axios.get('./data/vocabularies.json')
      .then(function (result) {
        setVocabularies(result.data);
      });
    axios.get('./data/searchFields.json')
    .then(function (result) {
      setSearchFields(result.data.searchFields);
    });
  }, [setLanguage, setVocabularies, setSearchFields]);

  if (vocabularies) {
    // localStorage.removeItem('lang');
    setArabicMarkup(localStorage.getItem('lang'));
    return children;
  }
  return null;
};

const mapStateToProps = (state) => ({
  vocabularies: state.vocabularies,
  err: state.err
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setVocabularies: data => setVocabularies(data),
      setLanguage: data => setLanguage(data),
      setSearchFields: data=> setSearchFields(data)
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppContainer));
